import { combineEpics } from 'redux-observable'
import { SplitFactory } from '@splitsoftware/splitio'

import config from 'config'
import * as actions from './actions'
import * as OrgActions from 'modules/org/actions'
import * as UserActions from 'modules/user/actions'
import * as OrgSelectors from 'modules/org/selectors'

import { logImpression } from 'utils/experiments'

export let client

const enrollUserInExperiment = (action$, store) => {
  return action$
    .ofType(OrgActions.createOrgSuccess.toString(), UserActions.fetchUserSuccess.toString())
    .pluck('payload')
    .first(() => {
      const orgId = OrgSelectors.getOrgId(store.getState())
      store.dispatch(actions.setPending())
      const factory = SplitFactory({
        core: {
          authorizationKey: config.SPLIT_ID,
          key: orgId,
          trafficType: 'organization'
        },
        impressionListener: {
          logImpression,
        },
      })
      client = factory.client()
      client.on(client.Event.SDK_READY, () => {
        store.dispatch(actions.setLoaded())
      })
      client.on(client.Event.SDK_READY_TIMED_OUT, () => {
        store.dispatch(actions.timedOut())
      })
    })
}

export const epic = combineEpics(
  enrollUserInExperiment,
)



// WEBPACK FOOTER //
// ./src/modules/experiment/epic.js